module.exports = __webpack_public_path__ + "img/dsAvancar.3e83d6ee.svg";